<template>
  <div id="admin">
    <AdminNav class="no-print" />
    <!-- 後臺選單 -->
    <Menu class="no-print" />
    <div class="mb-4 p-2 font text-left rounded home-div bg-white">
      <!-- 後台內容 -->
      <router-view class="pt-3 px-3 home-color" />
    </div>
  </div>
</template>

<script>
import Menu from '../components/Layout/Menu.vue'
import AdminNav from '../components/Layout/AdminNav.vue'
export default {
  name: 'admin',
  components: {
    Menu,
    AdminNav
  }
}
</script>
